export default Object.freeze({
    MONTLY: 'montly',
    WEEKLY: 'weekly',
    DAILY: 'daily',
})
